import { render, staticRenderFns } from "./FrameRegister.vue?vue&type=template&id=27b10d78"
import script from "./FrameRegister.vue?vue&type=script&lang=js"
export * from "./FrameRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports